// libs
import { createContext, useContext } from 'react';

// defs
import { IDisplayAppliedFilters } from 'shared/layouts/Listing/types';
import { ICurrentSelectedFilters } from 'shared/layouts/Listing/ListingMobile/components/FiltersBottomSheet/types';

interface IListingAPIContext {
  fetchPage: (page: number) => void;
  updateFilter: (filterKey: string, value?: string | number | string[]) => void;
  updateUIPage: (page: number) => void;
  clearFilter: (doUpdateURI?: boolean) => void;
  updateURI: (page?: number) => void;
  updateBulkFilters: (filterValues: Listing.IAppliedFilters) => void;
  showFiltersOverlay: boolean;
  setShowFiltersOverlay: (shouldShowOverlay: boolean) => void;
  selectedFilterKey: string;
  updateFilterWithDisplayFilters: (filterKey: string, value?: string | number | string[]) => void;
  setSelectedFilterKey: (filterKey: string) => void;
  displayAppliedFilters: IDisplayAppliedFilters[];
  setDisplayAppliedFilters: (value: IDisplayAppliedFilters[]) => void;
  updateDisplayFiltersWithLocalFilters: (localFilters: ICurrentSelectedFilters) => void;
}

const EMPTY_FUNC = () => {};

const initialValue: IListingAPIContext = {
  fetchPage: EMPTY_FUNC,
  updateFilter: EMPTY_FUNC,
  clearFilter: EMPTY_FUNC,
  updateURI: EMPTY_FUNC,
  updateUIPage: EMPTY_FUNC,
  updateBulkFilters: EMPTY_FUNC,
  showFiltersOverlay: false,
  setShowFiltersOverlay: EMPTY_FUNC,
  selectedFilterKey: '',
  setSelectedFilterKey: EMPTY_FUNC,
  updateFilterWithDisplayFilters: EMPTY_FUNC,
  displayAppliedFilters: [],
  setDisplayAppliedFilters: EMPTY_FUNC,
  updateDisplayFiltersWithLocalFilters: EMPTY_FUNC,
};

const ListingApiContext = createContext(initialValue);

export const useListingApiContext = () => useContext(ListingApiContext);

export default ListingApiContext;
